<template lang="pug">
	div.default-modal
		loading(:active.sync="busy", :is-full-page="false")
		.modal-header
			.modal-title {{ isMarketplacePublisher ? 'Edit Marketplace Placement' : 'Edit Placement' }} <span v-if="placement">({{ placement.id }})</span>
			a.close(href="javascript:void(0);", @click="$emit('close')")
				i.la.la-times
		.modal-body
			.modal-body-inner
				form(@submit.prevent="submit", v-if="placement")

					.row
						.col-sm-6
							.form-group
								label Status
								select.form-control(v-model="placement.status", name="status")
									option(v-for="o in statusOptions", :value="o.v") {{ o.t }}

					.row(v-if="isDspMarketplacePlacement")
						.col-sm-12
							.form-group
								clicks-volume(v-model="placement.clicks_frequency")

					h4.widget-section-title Caps
					.row
						.col-sm-6
							.form-group(v-b-tooltip.hover :disabled="!placement.is_cr_optimized" title="Managed by offer's KPI")
								label Click Cap
								scheduled-input(v-model="placement.daily_click_cap", :scheduledChange="scheduledChanges.daily_click_cap", fieldName="daily_click_cap", :entityId="placement.id", entityType="placement" :readonly="placement.is_cr_optimized")
						.col-sm-6
							.form-group(v-b-tooltip.hover :disabled="!placement.is_cr_optimized" title="Managed by offer's KPI")
								label Impressions Cap &nbsp;
								i.la.la-info-circle(v-if="placement.daily_click_cap > 0 && !placement.daily_impression_cap && !isImprRateCapDerived(placement.impression_rate, USER.config.impressionCapAutoCalculation)", v-b-tooltip.hover.right, title="There is no cap on impressions, but once the click cap is reached placement will be paused")
								scheduled-input(v-model="placement.daily_impression_cap", :scheduledChange="scheduledChanges.daily_impression_cap", fieldName="daily_impression_cap", :entityId="placement.id", entityType="placement", :readonly="placement.is_cr_optimized || isImprRateCapDerived(placement.impression_rate, USER.config.impressionCapAutoCalculation)")

					.row
						.col-sm-6
							.form-group(v-b-tooltip.hover :disabled="!placement.is_cr_optimized" title="Managed by offer's KPI")
								label Conversion Cap
								scheduled-input(v-model="placement.daily_conversion_cap", :scheduledChange="scheduledChanges.daily_conversion_cap", fieldName="daily_conversion_cap", :entityId="placement.id", entityType="placement", :readonly="placement.is_cr_optimized")
								div Offer: {{ placement.offer.daily_conversion_cap }}
								div Effective Risk: {{ effective_risk }} %
								div Visible Cap: {{ visible_cap }}
								div Conversion: {{ conversion }}
								p.form-text.text-muted(v-if="isMarketplacePublisher && isRewardedMarketplacePlacement") Minimum conversion cap is 30 or open (0).
						.col-sm-6
							.form-group(v-b-tooltip.hover :disabled="!placement.is_cr_optimized" title="Managed by offer's KPI")
								label 
									| Daily Install Cap
									i.la.la-info-circle.ml-1(v-if="isCpiPayout", v-b-tooltip.hover.bottom, title="Please use Conversion Cap on CPI placements")
								scheduled-input(v-model="placement.daily_install_cap", :scheduledChange="scheduledChanges.daily_install_cap", fieldName="daily_install_cap", :entityId="placement.id", entityType="placement", :readonly="isCpiPayout || placement.is_cr_optimized", :disabled="isCpiPayout")
								div Offer: {{ placement.offer.daily_install_cap }}

					h4.widget-section-title(v-if="!isMarketplacePublisher") Pacing
					.row(v-if="!isMarketplacePublisher")
						.col-sm-6
							.form-group
								label Click pacing (Minute)
								number-input(v-model="placement.click_pacing")
								p.form-text.text-muted(v-if="!placement.click_pacing") No limit of clicks / minute
								p.form-text(v-if="placement.click_pacing") Max {{placement.click_pacing | numberCommas }} clicks / minute
					.row(v-if="!isMarketplacePublisher")
						.col-sm-6
							.form-group
								label Click pacing (Hour)
								number-input(v-model="placement.click_pacing_hour")
								p.form-text.text-muted(v-if="!placement.click_pacing_hour") No limit of clicks / hour
								p.form-text(v-if="placement.click_pacing_hour") Max {{placement.click_pacing_hour | numberCommas }} clicks / hour
					.row(v-if="!isMarketplacePublisher")
						.col-sm-6
							.form-group
								label Impression pacing (Minute)
								number-input(v-model="placement.impression_pacing")
								p.form-text.text-muted(v-if="!placement.impression_pacing") No limit of impressions / minute
								p.form-text(v-if="placement.impression_pacing") Max {{placement.impression_pacing | numberCommas }} impressions / minute
						.col-sm-6
							.form-group
								label Impression pacing (Hour)
								number-input(v-model="placement.impression_pacing_hour")
								p.form-text.text-muted(v-if="!placement.impression_pacing_hour") No limit of impressions / hour
								p.form-text(v-if="placement.impression_pacing_hour") Max {{placement.impression_pacing_hour | numberCommas }} impressions / hour

					h4.widget-section-title.mt-2(v-if="!isMarketplacePublisher") Payout
					.row(v-if="!isMarketplacePublisher")
						.col-sm-12
							.form-group
								label Payout Mode
								select.form-control(v-model="placement.payout_mode", @change="onPayoutModeChange")
									option(value="fixed") Fixed
									option(value="dynamic") Dynamic
					.row(v-if="!isMarketplacePublisher")
						.col-sm-6(v-if="placement.payout_type === 'CPI' || placement.payout_mode === 'dynamic'")
							.form-group
								label {{ placement.payout_mode === 'fixed' ? 'Install Payout' : 'Payout %' }}
								.input-group-wrapper
									.input-group
										input.form-control(type="text", placeholder="0.00", v-model="placement.payout")
										.input-group-append
										span.input-group-text(v-if="placement.payout_mode === 'dynamic'") %
										span.input-group-text(v-if="placement.payout_mode === 'fixed'") $
									p.form-text(v-if="placement.payout_mode === 'fixed' && offer && offer.payout_type === 'CPI'") Offer payout: <span>{{ offer.payout }}</span>
						div(:class="placement.payout_type === 'CPI' || placement.payout_mode === 'dynamic' ? 'col-sm-6' : 'col-sm-12'")
							.form-group
								label Currency
								select.form-control(v-model="placement.currency")
									option(v-for="o in currencyOptions", :value="o.v", :disabled="o.disabled") {{ o.t }}
					.row(v-if="!isMarketplacePublisher")
						.col-sm-6
							.form-group(v-b-tooltip.hover title="On Dynamic payout mode the placement's payout model equals the offer's payout model" :disabled="placement.payout_mode !== 'dynamic'")
								label Payout Model
								select.form-control(
									:value="placement.payout_mode === 'dynamic' ? effectivePayoutType : placement.payout_type",
									:disabled="placement.payout_mode === 'dynamic'",
									@change="placement.payout_type = $event.target.value")
									option(v-for="o in payoutTypeOptions", :value="o.v") {{ o.v }}
								p.form-text Offer payout type: <span v-if="offer">{{ offer.payout_type }}</span>
							.form-group
								b-form-checkbox(v-model="placement.allow_multiple_conversions", :disabled="placement.payout_type !== 'CPA'") Allow multiple conversions for the same click

						.col-sm-6(v-if="placement.payout_type === 'CPA'")
							.form-group(v-b-tooltip.hover title="On Dynamic payout mode all offer's events will be payable as well" :disabled="placement.payout_mode !== 'dynamic'")
								label Payable Events
								multiselect(
									:multiple="true",
									:options="offer.events",
									:disabled="placement.payout_mode === 'dynamic'",
									:value="placement.payable_events",
									@select="onSelectPayableEvent",
									@remove="onRemovePayableEvent",
									track-by="name",
									label="name",
									deselect-label="",
									select-label="")
								p.form-text(v-if="offer_payable_event") Offer payable event: {{ offer_payable_event }}

					div(v-if="!isMarketplacePublisher && placement.payout_mode === 'fixed' && placement.payout_type === 'CPA'") 
						.form-group
							table.table.table-bordered
								thead
									tr
									th Event
									th Payout
									th Offer's Payout
								tbody
									tr(v-for="e in placement.payable_events")
										td {{ e.name }}
										td
											input.form-control(type="text", placeholder="0.00", v-model="e.payout", @blur="onEventPayoutBlur(e)")
										td
											input.form-control(type="text", placeholder="0.00", :value="getOffersEventPayout(e)", disabled="true")

					div(v-if="!isMarketplacePublisher && USER.permissions['placements::RISK']")
						.row
							.col-sm-6
								.form-group
									label &nbsp;
									.toggle-wrapper
										full-transparency-disabled-tooltip(:enabled="isFullTransparency")
											toggle-button(v-model="placement.custom_report", :disabled="isFullTransparency", :color="fullTransparencyDisabledSwitchColor", :width="40", :height="20", :font-size="14")
										span.lbl Override auto-report
											i.la.la-info-circle.ml-1(v-if="!isFullTransparency", v-b-tooltip.hover.right, title="When enabled - publisher's risk is ignored and determined by this configuration")
							.col-sm-6(v-if="placement.custom_report && !isFullTransparency")
								.form-group
									label Risk Management
									.input-group
										input.form-control(type="text", placeholder="", v-model.number="placement.risk_management")
										div.input-group-append
											span.input-group-text %
						

					h4.widget-section-title(v-if="!isMarketplacePublisher") Other
					.row(v-if="!isMarketplacePublisher")
						.col-sm-12(v-if="USER.config && USER.config.impressionRate")
							.form-group
								impratio(
								v-model="placement.impression_rate",
								:click-cap="placement.daily_click_cap",
								:impression-cap="placement.daily_impression_cap",
								@update-impression-cap="applyDerivedPlacementImpressionCap(placement, $event)"
								)
						.col-sm-12
							.form-group
								label Comments
								textarea.form-control(rows="3", placeholder="Comments (Internal use)", v-model="placement.comments")

					p.clearfix &nbsp;
					.buttons.text-right
						button.btn.btn-primary(type="submit") Save
							i.la.la-fw.la-save
</template>
<script>
import Vue from 'vue';
import { copy } from '../../lib/objects';
import { buildPayableEventOnSelect, getOfferEventPayout, getPublisherDefaultPlacementPayout, normalizePayableEventPayoutInput, syncPlacementPayoutFromPayableEvents } from '@/utils/buildPublisherPlacementForConnect';
import {
	applyDerivedPlacementImpressionCap,
	isImprRateCapDerived,
} from '../../utils/impression-rate-ctr-goal';
import { getEffectivePlacementPayoutType } from '../../utils/placementPayoutType';
import { CLICKS_VOLUME_DEFAULT, clampClicksVolume } from '@/utils/clicksVolume';
import FullTransparencyDisabledTooltip, { FULL_TRANSPARENCY_DISABLED_SWITCH_COLOR } from '../../components/FullTransparencyDisabledTooltip.vue';

export default {
	name: 'QuickEditPlacementModal',
	components: { FullTransparencyDisabledTooltip },
	props: ['id'],
	watch: {
		"placement.payout_type": {
			handler(v) {
				if (this.placement && v !== 'CPA') {
					this.placement.allow_multiple_conversions = false;
				}
			},
			immediate: true,
		},
	},
	methods: {
		applyDerivedPlacementImpressionCap,
		isImprRateCapDerived,
		onPayoutModeChange(event) {
			if (event.target.value === 'dynamic') {
				this.placement.payable_events = [];
				this.placement.payout_type = getEffectivePlacementPayoutType({
					payoutType: this.placement.payout_type,
					payoutMode: 'dynamic',
					offerPayoutType: this.offer.payout_type,
					isMarketplace: this.isMarketplacePublisher,
					publisherMediaType: this.publisher && this.publisher.media_type,
				});
			}
			this.placement.payout_mode = event.target.value;
		},
		onSelectPayableEvent(selectedOption) {
			this.placement.payable_events.push(
				buildPayableEventOnSelect(this.offer, this.placement, selectedOption, this.defaultPlacementPayout)
			);
			syncPlacementPayoutFromPayableEvents(this.placement);
		},
		onRemovePayableEvent(removedOption) {
			this.placement.payable_events = this.placement.payable_events.filter((e) => e.name !== removedOption.name);
			syncPlacementPayoutFromPayableEvents(this.placement);
		},
		onEventPayoutBlur(event) {
			this.$set(event, 'payout', normalizePayableEventPayoutInput(event.payout));
			syncPlacementPayoutFromPayableEvents(this.placement);
		},
		getOffersEventPayout(event) {
			return getOfferEventPayout(this.offer, event);
		},
		async submit() {
			if (this.busy) {
				return;
			}

			if (this.isMarketplacePublisher) {
				const conversionCap = +this.placement.daily_conversion_cap || 0;
				if (this.isRewardedMarketplacePlacement && conversionCap > 0 && conversionCap < 30) {
					this.$ovNotify.error('Rewarded marketplace placements require a minimum conversion cap of 30 or open (0)');
					return;
				}
			}

			let data = Vue.util.extend({}, this.placement);
			Vue.ovData.placement._booleans.forEach((f) => {
				data[f] = data[f] ? 1 : 0;
			});
			this.busy = true;
			try {
				await this.$ovReq.post('placement/quickSave', data);
				this.$ovNotify.success('Placement has been saved');
				this.$emit('close');
			} catch (e) {
				console.error(e);
			}
			this.busy = false;
		},
	},
	computed: {
		USER() {
			return this.$store.state.user;
		},
		isFullTransparency() {
			return !!(this.publisher && this.publisher.full_transparency);
		},
		fullTransparencyDisabledSwitchColor() {
			return FULL_TRANSPARENCY_DISABLED_SWITCH_COLOR;
		},
		isMarketplacePublisher() {
			return this.publisher && this.publisher.publisher_type === 'marketplace';
		},
		defaultPlacementPayout() {
			return getPublisherDefaultPlacementPayout(this.publisher);
		},
		isRewardedMarketplacePlacement() {
			return this.publisher && this.publisher.media_type === 'rewarded';
		},
		isDspMarketplacePlacement() {
			return this.isMarketplacePublisher && this.publisher.media_type === 'dsp';
		},
		effectivePayoutType() {
			return getEffectivePlacementPayoutType({
				payoutType: this.placement && this.placement.payout_type,
				payoutMode: this.placement && this.placement.payout_mode,
				offerPayoutType: this.offer && this.offer.payout_type,
				isMarketplace: this.isMarketplacePublisher,
				publisherMediaType: this.publisher && this.publisher.media_type,
			});
		},
		isCpiPayout() {
			return this.effectivePayoutType === 'CPI';
		},
		effective_risk() {
			return this.placement.custom_report
				? this.placement.risk_management
				: (this.publisher && this.publisher.auto_report_risk);
		},
		visible_cap() {
			return Math.floor(
				(this.effective_risk / 100) *
				(this.placement.daily_conversion_cap || this.placement.offer.daily_conversion_cap),
			);
		},
		offer_payable_event() {
			if (!this.offer || this.offer.payout_type !== 'CPA') {
				return false;
			}
			return this.offer.events
				.filter((e) => e.payout_mode !== 'none' && !!e.payout)
				.map((e) => e.name)
				.join(',');
		},
		conversion() {
			const payoutType = this.effectivePayoutType;
			if (payoutType === 'CPA') return this.placement.payable_events.map((e) => e.name).join(', ');
			if (payoutType === 'CPI') return 'Install';
			return '';
		},

		currencyOptions() { return Vue.ovData.general.currencyOptions },
		payoutTypeOptions() { return Vue.ovData.general.payoutTypeOptions },
	},
	data() {
		return {
			busy: false,
			placement: null,
			publisher: null,
			scheduledChanges: {},
			initialPlacement: null,
			offer: null,
			statusOptions: [
				{ v: 'draft', t: 'Draft' },
				{ v: 'live', t: 'Live' },
				{ v: 'paused', t: 'Paused' },
				{ v: 'cancelled', t: 'Cancelled' },
			],
		};
	},
	async created() {
		this.busy = true;
		try {
			const res = await this.$ovData.placement.get(this.id, true);
			this.placement = res.entity;
			this.placement.clicks_frequency = clampClicksVolume(
				this.placement.clicks_frequency || CLICKS_VOLUME_DEFAULT,
			);
			this.publisher = this.placement.publisher;
			this.scheduledChanges = res.scheduledChanges;
			this.offer = this.placement.offer;
			this.initialPlacement = copy(this.placement);
		} catch (e) {
			console.error(e);
			this.$emit('close');
		}
		this.busy = false;
	},
};
</script>
